/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Createdby1Inputs */

const en_entity_createdby1 = /** @type {(inputs: Entity_Createdby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created By`)
};

const de_entity_createdby1 = /** @type {(inputs: Entity_Createdby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt von`)
};

/**
* | output |
* | --- |
* | "Created By" |
*
* @param {Entity_Createdby1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_createdby1 = /** @type {((inputs?: Entity_Createdby1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Createdby1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_createdby1(inputs)
	return de_entity_createdby1(inputs)
});
export { entity_createdby1 as "entity_createdBy" }